import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote } from "lucide-react";

/**
 * Feature-specific social-proof widget.
 *
 * Drop into any marketing page for a specific VAULT feature and it
 * renders a small, understated card with an approved testimonial
 * associated with that feature tag. Silent if no genuine testimonials
 * exist — never fabricates.
 */
export default function FeatureTestimonialWidget({ tag, limit = 1 }) {
    const [items, setItems] = useState([]);
    useEffect(() => {
        if (!tag) return;
        api.get(`/public/testimonials/feature/${tag}`, { params: { limit } })
           .then(r => setItems(r.data?.testimonials || []))
           .catch(() => setItems([]));
    }, [tag, limit]);

    if (!items.length) return null;
    return (
        <div className="border-l-2 border-amber-500 pl-5 py-3 my-8"
             data-testid={`feature-testimonial-${tag}`}>
            <div className="text-[10.5px] uppercase tracking-widest text-amber-800 font-semibold flex items-center gap-1.5 mb-2">
                <Quote size={11} /> A VAULT customer
            </div>
            {items.map(t => (
                <blockquote key={t.id} className="mb-4 last:mb-0">
                    <p className="text-[15px] leading-relaxed text-stone-800 italic">&ldquo;{t.quote}&rdquo;</p>
                    <footer className="text-[11.5px] text-stone-500 mt-2">
                        {t.display_name}
                        {t.role && ` · ${t.role}`}
                        {t.country && ` · ${t.country}`}
                    </footer>
                </blockquote>
            ))}
        </div>
    );
}
